<script setup>
import CoinTrack from '@/components/reviewer/CoinTrack.vue';
import { COIN_GOAL as GOAL } from '@/utils/coins';
import { toGroupedNumber } from '@/utils/number';

// Het coin-saldo van de reviewer als voortgangsbalk onder het logo in de
// sidebar, zoals de balk in de bovenbalk van ui-v1 (CoinAccountProgressBar).
// Een klik gaat naar "Mijn coins".
defineProps({
  rate: { type: Number, required: true },
  // In de ingeklapte sidebar alleen het muntje en het getal.
  collapsed: { type: Boolean, default: false },
});
</script>

<template>
  <router-link
    :to="{ name: 'reviewer-dashboard' }"
    class="coin-progress"
    :class="{ 'coin-progress--collapsed': collapsed }"
    :title="`${toGroupedNumber(rate)} / ${toGroupedNumber(GOAL)} ${$t('word.coins').toLowerCase()}`"
    data-testid="coin-progress"
  >
    <span class="coin-progress__head">
      <i class="fa fa-coins coin-progress__icon"></i>
      <span id="coin-account-progress-bar-value" class="coin-progress__value">{{ toGroupedNumber(rate) }}</span>
      <span v-if="!collapsed" class="coin-progress__label">{{ $t('word.coins') }}</span>
    </span>
    <coin-track v-if="!collapsed" :rate="rate"/>
  </router-link>
</template>

<style scoped>
.coin-progress {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  margin: 0 1rem 0.75rem;
  padding: 0.55rem 0.75rem;
  border: 1px solid var(--grey-color-lighter);
  border-radius: 0.75rem;
  background: #fff;
  color: var(--grey-color-darker);
  text-decoration: none;
  transition: border-color 150ms ease, box-shadow 150ms ease;
}

.coin-progress:hover,
.coin-progress:focus-visible {
  border-color: var(--primary-color-light);
  box-shadow: var(--shadow-soft);
}

.coin-progress--collapsed {
  align-items: center;
  margin: 0 0.5rem 0.75rem;
  padding: 0.45rem 0.25rem;
}

.coin-progress__head {
  display: flex;
  align-items: baseline;
  gap: 0.4rem;
  white-space: nowrap;
}

.coin-progress--collapsed .coin-progress__head {
  flex-direction: column;
  align-items: center;
  gap: 0.1rem;
}

.coin-progress__icon {
  /* Dezelfde groenblauwe gradient als de balk. */
  background: linear-gradient(90deg, var(--teal-color-400), var(--secondary-color));
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  font-size: 0.85rem;
}

.coin-progress__value {
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.1;
}

.coin-progress--collapsed .coin-progress__value {
  font-size: 0.75rem;
}

.coin-progress__label {
  color: var(--grey-color-dark);
  font-size: 0.75rem;
}

</style>
